import React from "react";

// components
import Typogaphy from "../Typography/Typography";
import { Option, Select, SimpleSelectStyle } from "./SelectStyle";

export const SimpleSelect = ({ onChange, items, width, title, name }) => {
  return (
    <SimpleSelectStyle>
      <Typogaphy size="14px" space=".3rem">
        {title ? title : "مرتب سازی :"}
      </Typogaphy>
      <Select
        defaultValue="انتخاب کنید"
        onChange={onChange}
        width={width}
        name={name}
      >
        {items?.map((item, index) => (
          <Option key={index} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
    </SimpleSelectStyle>
  );
};
